import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { format } from "date-fns";

export function getVehicleCategories() {
  return networkBackendRequest("/vehicle-category-options/", HTTP_METHODS.GET)
    .then((response) => response.json())
    .then((responseJson) => {
      return {
        maxVehicles: responseJson.limit_number_vehicles,
        labels: responseJson.vehicle_category_options.map((vehicleCategory) => {
          return {
            label: vehicleCategory.label,
            value: vehicleCategory.option,
          };
        }),
      };
    });
}

function formatTime(time) {
  const timeDate = new Date(time);
  return format(timeDate, "HH:mm");
}

export function getTimeslots(groups_num, withdrawal_sel) {
  return networkBackendRequest("/timeslots/", HTTP_METHODS.GET, {
    groups_num_gte: groups_num,
    withdrawal_date: withdrawal_sel,
  })
    .then((response) => response.json())
    .then((responseJson) => {
      const details = responseJson.timeslots.map((detail) => {
        return {
          timeslotId: detail.timeslot_id,
          startDate: detail.start,
          endDate: detail.end,
          label: formatTime(detail.start),
          value: detail.timeslot_id,
        };
      });
      details.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        } else if (a.label === b.label) {
          return 0;
        } else {
          return 1;
        }
      });
      return details;
    });
}

export function getDispatchers() {
  return networkBackendRequest("/customs-dispatchers/", HTTP_METHODS.GET)
    .then((response) => response.json())
    .then((responseJson) => {
      const details = responseJson.customs_dispatchers.map((detail) => {
        return {
          dispatcherId: detail.dispatcher_id,
          dispatcherName: detail.name,
          label: detail.name,
          value: detail.dispatcher_id,
        };
      });

      return details;
    });
}

export function saveAppointment(request, withdrawal_type) {
  const with_transport = withdrawal_type === "with_transport";
  const paramsWithVehicles = {
    customs_dispatcher_id: request.customsDispatcherId,
    timeslot_id: request.timeslotId,
    vehicles: request.vehicles.map((v) => {
      return {
        plate: v.plate,
        category_option: v.category_option,
        document_number: v.driverDocumentNumber,
        document_type: "dni",
      };
    }),
    withdrawal_type,
  };
  const paramsWithHandWithout = {
    customs_dispatcher_id: request.customsDispatcherId,
    timeslot_id: request.timeslotId,
    withdrawal_type,
  };

  return networkBackendRequest(
    `/appointments/${request.appointmentId}/`,
    HTTP_METHODS.PATCH,
    {},
    with_transport ? paramsWithVehicles : paramsWithHandWithout
  )
    .then((response) => response.json())
    .then((detail) => {
      return {
        id: detail.appointment_id,
        dispatcherId: detail.customs_dispatcher_json["external_id"],
        timeslotId: detail.timeslot["timeslot_id"],
        vehicles: detail?.vehicles,
      };
    });
}

export function driverVerification(driverDocumentNumber) {
  return networkBackendRequest(
    `/drivers/${driverDocumentNumber}/`,
    HTTP_METHODS.GET,
    {
      document_type: "dni",
    }
  ).then((response) => response.json());
}
